import { Col, Progress } from "antd";
import React from "react";
import { QuotaData } from "./QuotaTableType";
import { ProgressDetailInfo } from "./ProgressDetailInfo";

interface ProgressDisplayProps {
  quotaOwnerData: QuotaData | null;
}

export const QuotaTableDetails: React.FC<ProgressDisplayProps> = ({
  quotaOwnerData,
}) => {
  return (
    <>
      {quotaOwnerData && (
        <>
          {Object.entries(quotaOwnerData).map(([section, details]) => {
            if (section === "owner_name") {
              return null;
            }
            if (typeof details === "object") {
              return (
                <Col xs={24} sm={24} md={12} lg={8} xl={8} key={section}>
                  <div className="quota-section">
                    <div>
                      <p className="quota-section-title">{section}</p>
                    </div>
                    <Progress
                      type="circle"
                      percent={details.used_percent}
                      strokeWidth={5}
                      strokeColor={{
                        "0%": "#36BDBE",
                        "100%": "#36BDBE",
                      }}
                      format={() => (
                        <div>
                          <div className="progress_inner_text">{`Usage ${details.quota_gb} GB`}</div>
                          <div className="progress_inner_sub_text">
                            {`Total `}
                            <span className="percentage-value">{`${details.used_percent}%`}</span>
                            {` Used of 100%`}
                          </div>
                        </div>
                      )}
                    />
                    <ProgressDetailInfo details={details} />
                  </div>
                </Col>
              );
            }
            return null;
          })}
        </>
      )}
    </>
  );
};
